/**
 * External dependencies
 */
import { some } from 'lodash';

/**
 * Internal dependencies
 */
import getReport from './get-report';
import getEdits from './get-edits';

export default (state, reportId) => {
	const report = getReport(state, reportId);
	const edits = getEdits(state, reportId);

	if (!report && edits) {
		return true;
	}

	if (!report) {
		return false;
	}

	const editsDirty = some(edits, (value, key) => {
		return report[key] !== value;
	});

	return editsDirty;
};
